import { Layout } from 'antd';
import HeaderLayout from "../../layout/Header";
import NavBarLayout from "../../layout/NavBar";
import FooterLayout from "../../layout/Footer";
import { isMobile } from "react-device-detect";
import { useCookies } from 'react-cookie';
import { Space, Table, Tag, Button, Modal, Form, Input, Select, message, Spin ,AutoComplete} from 'antd';
import { useState, useEffect } from 'react';
import { getLocalStorageInfo ,getLocalToken} from '../../utils/Common';
import axios from 'axios';
const globalConst = require('../../constants/global_const');

function Department(){
    const [isLoading, setIsLoading] = useState(true);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [cookies] = useCookies(['call_token']);
    const curToken = cookies.call_token ? cookies.call_token : getLocalToken();
    const [departmentData, setDepartmentData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [isEditUser, setIsEditUser] = useState(false);
    const [isWaiting, setIsWaiting] = useState(false);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [teamOptions, setTeamOptions] = useState([]);
    const showModal = (department = null) => {
        setModalTitle(department ? '部署情報を更新する' : '新しい部署を追加する');
        form.resetFields();
        if (department) {
            form.setFieldsValue({
				name: department.name,
                departmentId: department.id,
			});
            setIsEditUser(true);
        } else {
            setIsEditUser(false);
            form.setFieldsValue({ departmentId: -1 });
        }
        setModalVisible(true);
    };

    const fetchDepartmentData = async () => {
        try {
            const result = await axios.get('/api/departments', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${curToken}`,                },
            });
            setIsLoading(false);
            setDepartmentData(result.data.data || []);
        }
        catch (error) {
            console.error('Error fetching department data: ', error);
            setIsLoading(false);
        }
    }
    const handleModalCancel = () => {
        setModalVisible(false);
    };
    const addDepartment = async (values) => {
        setIsWaiting(true);
        try {
            await axios.post('/api/departments', values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${curToken}`,
                },
            });
            messageApi.success('部署が正常に追加されました');
            fetchDepartmentData();
        } catch (error) {
            console.error('Error adding department: ', error);
            messageApi.error('部署の追加に失敗しました');
        } finally {
            setIsWaiting(false);
        }
    }
    const editDepartment = async (values) => {
        setIsWaiting(true);
        try {
            await axios.put(`/api/departments/${values.departmentId}`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${curToken}`,
                },
            });
            messageApi.success('部署が正常に更新されました');
            fetchDepartmentData();
        }   catch (error) {
            console.error('Error updating department: ', error);
            messageApi.error('部署の更新に失敗しました');
        } finally {
            setIsWaiting(false);
        }
    }
    const handleFormSubmit = async (values) => {
        if (values.departmentId == -1) {
            await addDepartment(values);
        } else {
            await editDepartment(values);
        }
        setModalVisible(false);
    };
    useEffect(() => {
        fetchDepartmentData();
    }, []);
    const columns = [
        {
            title: '部署',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '課',
            dataIndex: 'sections',
            key: 'sections',
            render: (sections) => sections?.map(s => (
                <Tag key={s.id}>{s.name}</Tag>
            ))
        },
        {
            title: 'チーム',
            dataIndex: 'sections',
            key: 'teams',
            render: (sections) => sections?.flatMap(s => s.teams).map(t => (
                <Tag key={t.id}>{t.name}</Tag>
            )) ?? '-',
        },
    ]
    return(
        <Layout>
            <HeaderLayout />
            <Layout>
                <NavBarLayout />
                <Layout style={{ padding: '0 24px 24px',...(isMobile && { marginTop: "64px" }) }}>
                     <div style={{ minHeight: 780 }}>
                        {isLoading ? (
                            <div
                                style={{
                                height: "100vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                backgroundColor: "transparent",
                                }}
                            >
                                <Spin size="large" />
                                <div className="ms-3 mt-2">読み込み中</div>{" "}
                            </div>
                        ) : (
                        <>
                            <Button type="primary" onClick={() => showModal()}  style={{ marginTop: "10px",marginBottom: "10px" }}>新しい部署を追加または更新する</Button>
                            <Table
                                columns={columns}
                                pagination={{ position: ['bottomRight'] }}
                                dataSource={departmentData}
                                rowKey="id"
                                scroll={isMobile ? { x: true } : undefined}
                            />
                            <Modal
                                title={modalTitle}
                                open={modalVisible}
                                onCancel={handleModalCancel}
                                footer={null}
                            >
                                <Form
                                    {...{
                                        labelCol: { span: 8 },
                                        wrapperCol: { span: 16 },
                                    }}
                                    form={form}
                                    onFinish={handleFormSubmit}
                                >
                                    <Form.Item
                                        name="name"
                                        label="名前"
                                        rules={[{ required: true }]}
                                    >
                                         <AutoComplete
                                            placeholder="部署名を選択または入力"
                                            options={departmentData.map(dept => ({ label: dept.name, value: dept.name }))}
                                            filterOption={(input, option) =>
                                                input === '' ? true : (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            onSelect={(value) => {
                                                const selected = departmentData.find(dept => dept.name === value);
                                                if (selected) {
                                                    form.setFieldValue('departmentId', selected.id);
                                                    setSectionOptions(selected.sections.map(s => ({ label: s.name, value: s.name })));
                                                }
                                            }}
                                            onClear={() => {
                                                form.setFieldValue('departmentId', -1);
                                                form.setFieldValue('section', null);
                                                form.setFieldValue('team', null);
                                                setSectionOptions([]);
                                                setTeamOptions([]);
                                            }}
                                            onChange={(value) => {
                                                if (!value) {
                                                    form.setFieldValue('departmentId', -1);
                                                    form.setFieldValue('section', null);
                                                    form.setFieldValue('team', null);
                                                    setSectionOptions([]);
                                                    setTeamOptions([]);
                                                }
                                            }}
                                            allowClear
                                        />


                                    </Form.Item>
                                    
                                    <Form.Item
                                        name="section"
                                        label="課"
                                    >
                                        <AutoComplete
                                            placeholder="課を選択または入力"
                                            options={sectionOptions}
                                            filterOption={(input, option) =>
                                                input === '' ? true : (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            onSelect={(value) => {
                                                const currentDepartmentId = form.getFieldValue('departmentId');
                                                const currentDepartment = departmentData.find(d => d.id === currentDepartmentId);
                                                const selected = currentDepartment?.sections.find(s => s.name === value);
                                                if (selected) {
                                                    form.setFieldValue('sectionId', selected.id);
                                                    setTeamOptions(selected.teams.map(t => ({ label: t.name, value: t.name })));
                                                }
                                            }}
                                            onClear={() => {
                                                form.setFieldValue('sectionId', -1);
                                                form.setFieldValue('team', null);
                                                setTeamOptions([]);
                                            }}
                                            allowClear
                                            onChange={(value) => {
                                                if (!value) {
                                                    form.setFieldValue('sectionId', -1);
                                                    form.setFieldValue('team', null);
                                                    setTeamOptions([]);
                                                }
                                            }}

                                        />
                                    </Form.Item>
                                    <Form.Item name="team"  label="チーム">
                                        <AutoComplete
                                            placeholder="チームを選択または入力"
                                            options={teamOptions}
                                            filterOption={(input, option) =>
                                                input === '' ? true : (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            onSelect={(value) => {
                                                const currentSectionId = form.getFieldValue('sectionId');
                                                const selected = departmentData
                                                    .flatMap(dept => dept.sections)
                                                    .find(s => s.id === currentSectionId)
                                                    ?.teams.find(t => t.name === value);
                                                if (selected) {
                                                    form.setFieldValue('teamId', selected.id);
                                                }
                                            }}
                                            onChange={(value) => {
                                                if (!value) {
                                                    form.setFieldValue('teamId', -1);
                                                }
                                            }}
                                            onClear={() => form.setFieldValue('teamId', -1)}
                                            allowClear
                                        />
                                    </Form.Item>

                                    <Form.Item name="departmentId" hidden><Input /></Form.Item>
                                    <Form.Item name="sectionId" hidden><Input /></Form.Item>
                                    <Form.Item name="teamId" hidden><Input /></Form.Item>
                                    <Form.Item
                                        wrapperCol={{
                                            offset: 8,
                                            span: 16,
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit" loading={isWaiting}>更新する</Button> &nbsp;&nbsp;
                                        <Button htmlType="button" onClick={handleModalCancel}>キャンセル</Button>
                                    </Form.Item>
                                </Form>
                            </Modal>
                        </>)}
                     </div>
                    <FooterLayout />
                </Layout>
            </Layout>
        </Layout>
    );
}
export default Department;
